import { useState } from "react";

export const useTabs = (ideasPicked, attributesPicked, componentsPicked, projectsPicked) => {
  const [activeTab, setActiveTab] = useState(0);
  const types = ["PROJECTS", "COMPONENTS", "ATTRIBUTES", "IDEAS"];

  const getActiveTypeAndSize = () => {
    const type = types[activeTab];

    let size = "";
    const ideas = [
      ...ideasPicked.contradictionsSolvingsIds,
      ...ideasPicked.detailsMatrixIds,
      ...ideasPicked.eurekasIds,
      ...ideasPicked.replacmentsIds,
      ...ideasPicked.multiplicationsIds,
      ...ideasPicked.subtractionsIds,
    ];

    switch (type) {
      case "PROJECTS":
        size = projectsPicked.length === 0 ? "_EMPTY" : projectsPicked.length === 1 ? "_ONE" : "";
        return `${type}${size}`;
      case "IDEAS":
        size = ideas.length === 0 ? "_EMPTY" : ideas.length === 1 ? "_ONE" : "";
        return `${type}${size}`;
      case "ATTRIBUTES":
        size = attributesPicked.length === 0 ? "_EMPTY" : attributesPicked.length === 1 ? "_ONE" : "";
        return `${type}${size}`;
      case "COMPONENTS":
        size = componentsPicked.length === 0 ? "_EMPTY" : componentsPicked.length === 1 ? "_ONE" : "";
        return `${type}${size}`;
      default:
    }
  };

  return {
    activeTab,
    setActiveTab,

    getActiveTypeAndSize,
  };
};
